App.filter('link', function(){
    return function(model, link){
        if(link){
            var l = link.state || 'app.entity';
            l += "({action:'" + link.action + "',";
            l += "type:'" + link.type + "',";
            l += "filter:'" + (link.filterValue ? link.filterValue: (link.filter ? model[link.filter] : '')) + "'})";
            return l;
        } else {
            return 'app';
        }
    }
});
